<template>
  <v-dialog v-model="showDetailDialog" max-width="60%" persistent>
    <v-card class="window-card px-4 py-5">
      <v-card-title>
        <span class="md-title" style="color: #67ad5b">角色模型信息</span>
      </v-card-title>
      <v-card-text>
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50"
            style="padding-left: 0; padding-top: 7px"
          >
            <v-card class="px-3 py-3">
              <model-fbx
                style="width: 380px; height: 200px; margin: 3px"
                :src="currentResource.model_file"
                v-if="currentResource.model_file"
              />
              <img
                v-else
                style="width: 380px; height: 200px; margin: 3px"
                :src="currentResource.model_image"
                :alt="model_resource_category.cn_name + '图片'"
              />
              <v-btn color="success">
                <v-icon>restart_alt</v-icon>
              </v-btn>
            </v-card>
          </div>
          <v-form class="md-layout-item md-size-50">
            <v-text-field
              v-model="currentResource.model_name"
              label="名称 *"
              color="#4caf50"
            ></v-text-field>
            <v-select
              v-model="currentResource.profession"
              :items="majorListData"
              item-text="name"
              item-value="index"
              label="专业分类 *"
              color="#4caf50"
              :rules="[(v) => !!v || '专业分类不能为空']"
            ></v-select>
            <v-select
              v-model="currentResource.sex"
              :items="sexItems"
              item-text="name"
              item-value="value"
              color="#4caf50"
              label="性别"
            ></v-select>
            <v-text-field
              v-model="currentResource.age"
              label="年龄"
              color="#4caf50"
              hint="请输入您的年龄"
            ></v-text-field>
            <v-textarea
              v-model="currentResource.description"
              label="描述"
              color="#4caf50"
              dense
              auto-grow
            ></v-textarea>
            <v-textarea
              v-model="currentResource.model_remark"
              label="备注"
              color="#4caf50"
              dense
              auto-grow
            ></v-textarea>
          </v-form>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="submit">确定</v-btn>
        <v-btn color="error" @click="delete_">删除</v-btn>
        <v-btn color="success" @click="cancel">关闭</v-btn>
      </v-card-actions>
    </v-card>
    <md-snackbar md-active.sync="showDetailDialog" md-timeout="3000">
      {{ message }}
    </md-snackbar>
  </v-dialog>
</template>
<script>
import { ImageCard, Pagination } from "@/components";
import { ModelFbx } from "vue-3d-model";
import Swal from "sweetalert2";
import model_resource_name_map from "../../../../../common/config/model_resource_name_map";
import { updateModelResource, deleteResource } from "@/api/model_resource";

export default {
  components: {
    ImageCard,
    Pagination,
    ModelFbx,
  },
  props: {
    showDetailDialog: {
      type: Boolean,
      default: false,
    },
    selectedResource: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 专业分类
      majorListData: [],
      // 二级分类
      level2: [],
      // 三级分类
      level3: [],
      currentResource: this.selectedResource,
      message: "",
      sexItems: [
        { value: "0", name: "男" },
        { value: "1", name: "女" },
      ],
    };
  },
  mounted() {
    this.initDict("role");
    console.log(
      this.currentResource,
      this.currentResource.profession,
      this.currentResource.industry,
      this.currentResource.function_category
    );
  },
  computed: {
    model_resource_category() {
      return model_resource_name_map(this.$route.path);
    },
  },
  methods: {
    /**
     * 初始化字典
     */
    initDict(cate_type) {
      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: "1",
        },
        (res) => {
          this.majorListData = res;
        }
      );

      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: "2",
          parentCode: "00",
        },
        (res) => {
          this.level2 = res;
        }
      );

      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: "3",
          parentCode: "00_01",
        },
        (res) => {
          this.level3 = res;
        }
      );
    },
    cancel() {
      this.$emit("handleDetailCancel", {});
    },
    submit() {
      let tempData = {
        _id: this.currentResource._id,
        model_name: this.currentResource.model_name,
        profession: this.currentResource.profession,
        industry: this.currentResource.industry,
        model_category: this.currentResource.model_category,
        model_file_type: this.currentResource.model_file_type,
        function_category: this.currentResource.function_category,
        is_public: true,
        description: this.currentResource.description,
        sex: this.currentResource.sex,
        age: this.currentResource.age,
        remark: this.currentResource.remark,
      };
      updateModelResource(tempData).then((res) => {
        // console.log(res);
        if (res.code === "200") {
          this.$notify({
            timeout: 1500,
            message: "操作成功！",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "bottom",
            type: "success",
          });
          this.$emit("handleDetailSubmit", res.data);
        } else {
          this.$notify({
            timeout: 1500,
            message: "操作失败",
            horizontalAlign: "center",
            verticalAlign: "bottom",
            type: "warning",
          });
        }
      });
    },
    async delete_() {
      let tempData = {
        _id: this.currentResource._id,
      };
      let result = await Swal.fire({
        title: "删除信息",
        text: `该角色模型被删除后将无法恢复，请确认！`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        buttonsStyling: false,
      });
      if (result.value) {
        await deleteResource(tempData).then((res) => {
          if (res.code === "200") {
            this.message = "删除成功";
            this.$notify({
              timeout: 1500,
              message: "操作成功！",
              icon: "add_alert",
              horizontalAlign: "center",
              verticalAlign: "bottom",
              type: "success",
            });
            this.$emit("handleDetailSubmit", res.data);
          } else {
            this.$notify({
              timeout: 1500,
              message: "操作失败",
              horizontalAlign: "center",
              verticalAlign: "bottom",
              type: "warning",
            });
          }
        });
      }
    },
  },
};
</script>
<style lang="css" scoped>
.v-card .v-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.img {
  width: 120px;
  height: 180px;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 800px;
  max-height: 450px;
  overflow: auto;
}
</style>
